import React from "react";

const Terms = () => {
  return (
    <>
      <main className="mt-24 max-w-4xl mx-auto px-6 md:px-10 py-10 text-gray-800 leading-relaxed">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-medium text-[#1f2937] mb-2">
            Cura AI Terms of Use
          </h1>
          <p className="text-sm text-gray-500">Effective Date: 3rd March 2025</p>
        </div>

        <p className="mb-6">
          These Terms of Use, in accordance with the Privacy Policy, govern your access and use of
          all Cura AI applications for web and mobile devices (the “App”), the Cura AI website, and
          any content, information, and services provided by Cura AI (“Services”). If you do not
          agree to the full Terms of Use, you should not use the App.
        </p>

        <div className="space-y-6 text-[1.05rem]">
          <div>
            <h2 className="font-semibold text-lg mb-1">1. Introduction</h2>
            <p>
              These Terms of Use govern your access and use of Cura AI applications, the website,
              and the services provided through them. By using the Services, you agree to abide by
              these Terms and the Privacy Policy. If you do not agree, do not access or use the
              Services.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">2. Scope</h2>
            <p>
              Cura AI offers services for non-commercial use only. The App does not provide medical
              advice, and users should consult healthcare professionals before making health-related
              decisions.
              <br />
              <strong className="text-red-600 block mt-2">
                IMPORTANT: IN THE EVENT OF A MEDICAL EMERGENCY, CALL EMERGENCY SERVICES.
              </strong>
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">3. Account</h2>
            <p>
              You must create an account to use our Services. You are responsible for maintaining
              the confidentiality of your account and ensuring all information is accurate.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">4. Third-Party Communication</h2>
            <p>
              Cura AI is not responsible for the content of third-party communications facilitated
              through the platform.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">5. Permitted Uses</h2>
            <ul className="list-disc pl-6">
              <li>Do not engage in illegal or unauthorized activities using the Services.</li>
              <li>Do not attempt to harm individuals or entities through the platform.</li>
              <li>Do not reverse-engineer or modify the platform.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">6. Consent to Use of Data</h2>
            <p>
              By using our Services, you consent to the collection and storage of your data as
              outlined in our Privacy Policy.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">7. Rights to Data</h2>
            <p>Cura AI may use anonymized data to enhance its services.</p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">8. Updates</h2>
            <p>
              Cura AI may provide updates to the Services, and these Terms will govern any updates
              unless otherwise stated.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">9. Links to Third-Party Services</h2>
            <p>
              We do not endorse third-party services linked on our platform and are not responsible
              for their content.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">10. Termination</h2>
            <p>
              Cura AI may terminate your access to the Services at any time if you violate these
              Terms.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">11. Intellectual Property Rights</h2>
            <p>Cura AI reserves all intellectual property rights related to its services.</p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">12. Limitation of Warranty</h2>
            <p>The Services are provided "as is," without warranties of any kind.</p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">13. Limitation of Liability</h2>
            <p>
              Cura AI is not liable for damages arising from your use of the Services.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">14. Changes to the Terms of Use</h2>
            <p>
              We may modify these Terms from time to time. Your continued use of the Services
              constitutes acceptance of the changes.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">15. Governing Law</h2>
            <p>
              These Terms are governed by the laws of Canada and the courts of Vancouver, British
              Columbia.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-lg mb-1">16. Contact Us</h2>
            <p>
              For questions about these Terms, contact us at{" "}
              <a href="mailto:privacy@curaai.ca" className="text-blue-600 hover:underline">
                privacy@curaai.ca
              </a>
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default Terms;
